import { render, staticRenderFns } from "./newTransSheet.vue?vue&type=template&id=13a928fe"
import script from "./newTransSheet.vue?vue&type=script&lang=js"
export * from "./newTransSheet.vue?vue&type=script&lang=js"
import style0 from "./newTransSheet.vue?vue&type=style&index=0&id=13a928fe&prod&lang=stylus"
import style1 from "./newTransSheet.vue?vue&type=style&index=1&id=13a928fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports